module.exports = __webpack_public_path__ + "static/media/successful.78ef95da.svg";